module.exports = "/packs/american-express-5cc0d1b89a424d3794f9233d7ccc656d.png";